<template>
  <div class="themeBody" :data-theme="themeMode">
  <div class="mainBoxForm">

    <go-back-button :back-url="'/account/userCenter'">
      <template v-slot:body>
        <div class="deleteUserTitle">{{ $t('h.userCenter.cancelAccount') }}</div>
      </template>
    </go-back-button>

    <div class="deleteUserFormBox">
      <div class="empty-height"></div>

      <el-divider></el-divider>

      <div class="formBoxTip">{{$t('h.deleteUser.tipDeleteUser')}}</div>

      <el-checkbox class="myCheckBox" v-model="checked" name="checked">
        <template v-slot:default>
          {{$t('h.common.readAndAgree')}} <a class="agreeA" href="#/policies/deleteAccountPrivacy">{{$t('h.deleteUser.accountDeletionTerms')}}</a>
        </template>
      </el-checkbox>

      <!--      <input class="myCheckBox" type="checkbox" name="agreeTip" checked>-->
      <!--      <label for="agreeTip">我已阅读并同意<a class="agreeA" href="#/policies/deleteAccountPrivacy">账号删除条款</a></label>-->

      <el-button  class="elBtn" type="primary" @click="deleteAccount">{{$t('h.common.delete')}}</el-button>



    </div>

    <div class="pageFooter">
      <area-select-footer v-show="$store.state.isInSlicer==false"/>
      <copyright/>
    </div>
  </div>
  </div>
</template>

<script>

import {deleteUser} from "@/api/api";
import {OnClickGetLoginInfo} from "@/utils/studioWXMessage";
import {initializeLanguage} from "@/utils/utils";

export default {
  data() {
    return {
      nick_name: '',//用户名
      checked: false,//是否同意协议
    }
  },
  computed: {
    isActiveSub() {
      if (this.old_nick_name !== this.nick_name && this.old_nick_name !== "") {
        return false
      } else {
        return true
      }
    },
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  created() {
    this.getUseInfo()
  },
  methods: {
    getUseInfo() {
      if (localStorage.getItem("token") === "") {
        //this.$notify.error({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.tipNeedLogin'),
        // })
        this.$router.push("/account/login")
      } else {
        console.log('已经登录');
      }
    },
    deleteAccount() {
      if (this.checked !== true) {
        this.$confirm(this.$t('h.common.agreementRequired'), this.$t('h.common.tip'), {
          confirmButtonText: this.$t('h.common.agree'),
          cancelButtonText: this.$t('h.common.refuse'),
          type: 'warning',
          showClose: "false",
          dangerouslyUseHTMLString: "true",
        }).then(() => {
          //this.$notify.success({
          //   title: this.$t('h.common.tip'),
          //   message: this.$t('h.common.agree'),
          // });
          this.checked = true
          return true
        }).catch(() => {
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message: this.$t('h.common.refuse'),
          // });
          this.checked = false
          return false
        });
        return
      }
      //
      deleteUser().then((res) => {
        if (res.status === 0) {
          //如果删除账号成功也要执行退出账号的逻辑清空本地token和vuex的数据
          //this.$notify.success({
          //   title: this.$t('h.common.tip'),
          //   message: this.$t('h.common.tipDeleteAccountSuccess'),
          // });
          this.logout()
        } else {
          //this.$notify.error({
          //   title: this.$t('h.common.tip'),
          //   message:  this.$t('h.common.tipDeleteAccountFail'),
          // });
        }
      })
    },
    logout() {
      //发送空的token给软件表示退出登录
      OnClickGetLoginInfo("")

      localStorage.clear();
      this.$store.commit('deleteUserVuex')

      // 初始化语言设置
      const initialLanguage = initializeLanguage();
      this.$store.commit('setLanguage', initialLanguage); // 设置 Vuex 中的语言
      console.warn("initialLanguage",initialLanguage)
      localStorage.setItem('locale', initialLanguage); // 设置 localStorage 中的语言

      this.$router.push("/account/login")
      //this.$notify.success({
      //   title: this.$t('h.common.tip'),
      //   message: this.$t('h.common.tipLoginOut'),
      // });
    },
  },

}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.mainBoxForm {
  @include background_color("background_color");
  @include font_color("text-color");
}

>>> .deleteUserTitle {
  font-size: 30px;
  padding: 10px 0;
}

>>> .deleteUserBox {
  width: 600px;
  height: 555px;
  align-items: center;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 15px;

  position: relative;
  margin: 0 auto;
  margin-top: 10%;
}

>>> .deleteUserFormBox {
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  //border: 1px solid red;


  .formBoxTip {
    text-align: left;
  }

  .elBtn {
    width: 100%;
    margin: 0;
    margin-top: 40px;
  }

  .el-checkbox__inner {
    border: 2px solid #757575;
    border-radius: 5px;
    width: 15px;
    height: 15px;
  }

  .myCheckBox {
    margin-top: 20px;
    @include font_color("checkBoxColor");
  }

  /* 设置选中后的文字颜色 */
  .myCheckBox .el-checkbox__input.is-checked + .el-checkbox__label {
    @include font_color("checkBoxColor");
  }

  /* 设置选中后对勾框的边框和背景颜色 */
  .myCheckBox .el-checkbox__input.is-checked .el-checkbox__inner, .myCheckBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    @include border_color("qidi_blue");
    @include background_color("qidi_blue");
  }

  .agreeA {
    text-decoration: none;
    @include font_color("qidi_blue");
  }

  .agreeA:hover {
    text-decoration: underline;
  }

}


</style>



// WEBPACK FOOTER //
// src/views/account/deleteUser.vue